module.exports = __webpack_public_path__ + "img/odocs_logo_big_welcomescree.b7c3c854.png";